import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { DynamicDrawerService } from 'app/shared/dynamic-drawer.service';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-toggle-location-type',
  templateUrl: './toggle-location-type.component.html',
  styleUrls: ['./toggle-location-type.component.css']
})
export class ToggleLocationTypeComponent implements ICellRendererAngularComp, OnDestroy {
  readonly destroyed = new ReplaySubject(1);
  params: ICellRendererParams;
  agRowData: any;
  public type;

  constructor(readonly drawerService: DynamicDrawerService<any>,) { }


  get hasProperty() {
    return this.params?.data.hasProperty || false;
  }

  get hasTag() {
    return this.params?.data.hasTag || false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.agRowData = params.node.data;
    this.type = this?.params?.data.type;
    console.log('type', this.type);
  }

  /**
   * selection change event
   * @param checked checked value
   * @param changeEvent change event parameter
   */
  onTypeChange(type): void {
    console.log(`on type change ${type}`);
    this.type = type;
    this.params.data.type = this.type;
    this.drawerService._changeLocationAssetsType.next({ id: this.params.data.id, type: this.params.data.type, propertyId: this.params.data.propertyId, tagId: this.params.data.tagId, componentInstanceId: this.params.data.componentInstanceId, checked: this.params.data.checked })
    // this.params.api.refreshCells(this.params as any);
    // if (this.params?.node?.data) {
    //   if (checked) {
    //     this.linkAssetServiceService.addCheckedTagValue(this.params.node.data);
    //   } else {
    //     this.linkAssetServiceService.removeCheckedTagValue(this.params.node.data);
    //   }
    // }

  }

  refresh(params: any): boolean {
    this.params = params;
    return false;
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }


}
